new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_list',
    data: {
        menuFilter: false,
        listOpened: false,
        listEx: localStorage.getItem('listOrder') ? localStorage.getItem('listOrder') : localStorage.setItem('listOrder', 0),
        listExMobile: localStorage.getItem('listOrderMobile') ? localStorage.getItem('listOrderMobile') : localStorage.setItem('listOrderMobile', 0)
    },
    methods: {
      changeList(list) {
        this.listEx = list;
        localStorage.setItem('listOrder', list);
      },

      changeListMobile(list) {
        this.listExMobile = list;
        this.listOpened = false;
        localStorage.setItem('listOrderMobile', list);
      }
    },
    watch: {
        menuFilter(newValue) {
          if (newValue) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.removeProperty('overflow');
          }
        },
        listOpened(newValue) {
          if (newValue) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.removeProperty('overflow');
          }
        },
      }
})